import { Link } from 'react-router-dom';
import { APP_NAME, LOGO } from '../../brand';

export const EVENT_LABELS = {
  achat_valide: 'Achat validé', partie_creee: 'Lancer ouvert', partie_ouverte: 'Jeu ouvert',
  case_choisie: 'Case choisie', lot_gagne: 'Lot gagné', sans_lot: 'Case sans lot', lot_remis: 'Lot remis',
  participation_annulee: 'Participation annulée', choix_refuse: 'Tentative de rejeu refusée',
  cases_retirees: 'Cases tirées', reservation_expiree: 'Réservation expirée, stock rendu',
  ticket_refuse: 'Ticket déjà utilisé', stock_ajuste: 'Stock ajusté', campagne_creee: 'Session créée',
  campagne_modifiee: 'Session modifiée', campagne_supprimee: 'Session supprimée', quota_modifie: 'Quota modifié',
  lot_cree: 'Lot créé', lot_modifie: 'Lot modifié', produit_cree: 'Produit créé', produit_modifie: 'Produit modifié',
  reglages_modifies: 'Réglages modifiés',
};

export function describe(p) {
  return Object.entries(p || {}).filter(([, v]) => v !== null && v !== undefined && v !== '')
    .map(([k, v]) => `${k} : ${typeof v === 'object' ? JSON.stringify(v) : v}`).join(' · ');
}


/** Barre bleue des pages « Stocks », « Quotas », « Participants » (comme Supermont). */
export function PageNav({ user, title }) {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark sticky-top" style={{ background: '#1565c0', padding: '12px 0' }}>
      <div className="container">
        <Link className="navbar-brand fw-bold d-flex align-items-center" to="/admin" style={{ fontSize: '20px' }}>
          <div style={{ width: '40px', height: '40px', background: '#fff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '12px', border: '2px solid #42a5f5', overflow: 'hidden' }}>
            <img src={LOGO} alt="Supermont" style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '50%' }} />
          </div>
          <span>{APP_NAME}{title ? <> &mdash; {title}</> : null}</span>
        </Link>
        <div className="d-flex align-items-center">
          <span className="text-white me-3 d-none d-sm-inline"><i className="fas fa-user-shield me-2"></i>{user?.username}</span>
          <Link to="/admin" className="btn btn-outline-light btn-sm"><i className="fas fa-arrow-left me-2"></i>Retour</Link>
        </div>
      </div>
    </nav>
  );
}

export function PageAlert({ message, onClose }) {
  if (!message?.text) return null;
  return (
    <div className={`alert alert-${message.type === 'success' ? 'success' : 'danger'} alert-dismissible fade show mb-3`} role="alert">
      {message.text}
      <button type="button" className="btn-close" aria-label="Fermer" onClick={onClose}></button>
    </div>
  );
}

export function Modal({ title, icon, onClose, children, footer, size }) {
  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" aria-modal="true" style={{ background: 'rgba(0,0,0,0.7)' }} onClick={onClose}>
      <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable ${size || ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-content" style={{ background: '#fff', border: '1px solid #dee2e6', boxShadow: '0 4px 24px rgba(0,0,0,0.12)' }}>
          <div className="modal-header border-bottom">
            <h5 className="modal-title" style={{ color: '#1a1a1a' }}>
              {icon && <i className={`${icon} me-2`} style={{ color: '#1565c0' }}></i>}{title}
            </h5>
            <button type="button" className="btn-close" aria-label="Fermer" onClick={onClose}></button>
          </div>
          <div className="modal-body">{children}</div>
          {footer && <div className="modal-footer border-top-0">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export const inputStyle = { background: '#fff', borderColor: '#dee2e6', color: '#1a1a1a' };
